import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import moment from "moment";
import { post } from "../../../helpers/api_helper";
import {
  POST_GetCustomerDDLListAJAX,
  POST_GetReportAdvanceReceiptRegisterExport,
  POST_GetReportAdvanceReceiptRegisterList,
  POST_GetReportPaymentReceiptRegisterExport,
  POST_GetReportPaymentReceiptRegisterList,
} from "../../../helpers/url_helper";
import { errorMessage } from "../CommonFunctions";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";

const PaymentReceiptRegister = () => {
  const [showFilter, setShowFilter] = useState(true); //for report screen default true
  const [isLoading, setIsLoading] = useState(false);

  const [isReset, setIsReset] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const [paymentReceiptList, setPaymentReceiptList] = useState([]);
  const [advanceReceiptList, setAdvanceReceiptList] = useState([]);

  const paymentTypeOptions = [
    { label: "Receipt", value: 1 },
    { label: "Advance", value: 2 },
  ];

  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema: validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      FromDate: new Date(),
      ToDate: new Date(),
      CustomerIDEncrypted: "",
      CustomerName: "",
      PaymentType: 1,
      InvoiceNo: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      FromDate,
      ToDate,
      CustomerIDEncrypted,
      CustomerName,
      PaymentType,
      InvoiceNo,
    },
  } = formikFilter;

  const handleValidSubmitFilter = (values) => {
    getData();
  };

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      FromDate: new Date(),
      ToDate: new Date(),
      CustomerIDEncrypted: "",
      CustomerName: "",
      PaymentType: 1,
      InvoiceNo: "",
    });

    setIsReset(true);
  };

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  useEffect(() => {
    if (isReset == true) {
      getData();
      setIsReset(false);
    }
  }, [isReset]);

  const getData = async () => {
    setIsLoading(true);

    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InvoiceNo: InvoiceNo,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
    };

    await post(
      PaymentType == 2
        ? POST_GetReportAdvanceReceiptRegisterList
        : POST_GetReportPaymentReceiptRegisterList,
      payload
    )
      .then((response) => {
        if (PaymentType == 1) {
          setPaymentReceiptList(response?.List);
        }
        if (PaymentType == 2) {
          setAdvanceReceiptList(response?.List);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });

    setIsLoading(false);
  };

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InvoiceNo: InvoiceNo,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      ReportGenerateByIDEncrypted: AuthUser?.ReferenceIDEncrypt,
    };

    post(
      PaymentType == 2
        ? POST_GetReportAdvanceReceiptRegisterExport
        : POST_GetReportPaymentReceiptRegisterExport,
      payload
    )
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCustomerDDL_AJAX = async (inputValue) => {
    return await post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  const loadOptionsCustomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const handleChangePaymentType = (e) => {
    formikFilter.setFieldValue("PaymentType", e?.value ?? "");
    if (e && e?.value == 2) {
      formikFilter.setFieldValue("InvoiceNo", "");
    }
    setPaymentReceiptList([]);
    setAdvanceReceiptList([]);
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Payment Receipt Register</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i className="fa fa-window-restore me-2" aria-hidden="true"></i>
                    Reset
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 60 && x?.IsExport)
                    ?.length > 0 ? (
                    <Link
                      className="btn btn-outline-primary btn-sm me-2"
                      onClick={exportReport}
                    >
                      <i className="fa-solid fa-file-excel" /> Export Report
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={2}>
                            <label className="mb-1">Receipt Date</label>
                            <div className="d-flex">
                              <Field
                                name="FromDate"
                                placeholder={"From Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                              />
                              <div>&nbsp;</div>
                              <Field
                                name="ToDate"
                                placeholder={"To Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: FromDate,
                                }}
                              />
                            </div>
                          </Col>

                          <Col lg={3}>
                            <Field
                              label="Customer"
                              name="CustomerIDEncrypted"
                              placeholder={"Select Customer"}
                              loadOptionsFn={loadOptionsCustomer}
                              component={CustomSelectAsync}
                              title={CustomerName}
                              labelFieldName="CustomerName"
                              // menuPosition="fixed"
                            />
                          </Col>

                          <Col lg={2}>
                            <Field
                              label="Payment Type"
                              name="PaymentType"
                              placeholder={"Select Invoice Status"}
                              options={paymentTypeOptions}
                              component={CustomSelect}
                              isClearable={false}
                              // menuPosition="fixed"
                              onChange={handleChangePaymentType}
                            />
                          </Col>

                          {PaymentType == 1 && (
                            <Col lg={2}>
                              <Field
                                label="Invoice No"
                                name="InvoiceNo"
                                placeholder={"Search Invoice No"}
                                component={CustomInput}
                              />
                            </Col>
                          )}

                          <Col lg={1}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <button
                                  className="btn btn-primary btn-sm mb-1"
                                  type="submit"
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>
                                  {"  "} Search
                                </button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                <div className="table-responsive">
                  <div
                    id="PaymentReceitpRegister-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                    style={{ height: "510px", overflowY: "auto" }}
                  >
                    {PaymentType == 1 && (
                      <table
                        id="PaymentReceitpRegister-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead className="fixedheader">
                          <tr>
                            <th
                              width="2%"
                              style={{ minWidth: "50px", textAlign: "center" }}
                            >
                              #
                            </th>
                            <th width="5%" style={{ minWidth: "100px" }}>
                              Receipt No
                            </th>
                            <th width="5%" style={{ minWidth: "100px" }}>
                              Receipt Date
                            </th>
                            <th width="6%" style={{ minWidth: "120px" }}>
                              Invoice No
                            </th>
                            <th width="5%" style={{ minWidth: "100px" }}>
                              Invoice Date
                            </th>
                            <th width="6%" style={{ minWidth: "120px" }}>
                              Inward No
                            </th>
                            <th width="6%" style={{ minWidth: "120px" }}>
                              TC No
                            </th>
                            <th width="10%" style={{ minWidth: "200px" }}>
                              Customer Name
                            </th>
                            <th
                              width="5%"
                              style={{ minWidth: "100px", textAlign: "right" }}
                            >
                              Invoice Amount
                            </th>
                            <th
                              width="5%"
                              style={{ minWidth: "100px", textAlign: "right" }}
                            >
                              Received Amount
                            </th>
                            <th
                              width="5%"
                              style={{ minWidth: "100px", textAlign: "right" }}
                            >
                              TDS Amount
                            </th>
                            <th
                              width="5%"
                              style={{ minWidth: "100px", textAlign: "right" }}
                            >
                              Kasar
                            </th>
                            <th
                              width="5%"
                              style={{ minWidth: "100px", textAlign: "right" }}
                            >
                              Bank Charges
                            </th>
                            <th
                              width="5%"
                              style={{ minWidth: "100px", textAlign: "right" }}
                            >
                              Pending Amount
                            </th>
                            <th width="5%" style={{ minWidth: "100px" }}>
                              Payment Mode
                            </th>
                            <th width="5%" style={{ minWidth: "100px" }}>
                              Received Detail
                            </th>
                            <th width="5%" style={{ minWidth: "100px" }}>
                              Receivable Bank Name
                            </th>
                            <th width="5%" style={{ minWidth: "100px" }}>
                              Contact Person
                            </th>
                            <th
                              width="5%"
                              style={{ minWidth: "100px", textAlign: "left" }}
                            >
                              Entry By
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {paymentReceiptList?.length > 0 ? (
                            <>
                              {paymentReceiptList?.map((item, index) => (
                                <tr key={index}>
                                  <td style={{ textAlign: "center" }}>
                                    {item?.RowNo}
                                  </td>
                                  <td>{item?.PaymentReceiptNo}</td>
                                  <td>{item?.PaymentDate}</td>
                                  <td>{item?.InvoiceNo}</td>
                                  <td>{item?.InvoiceDate}</td>
                                  <td
                                    style={{
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item?.InwardNo}
                                  </td>
                                  <td
                                    style={{
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item?.TCNo}
                                  </td>
                                  <td
                                    style={{
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item?.CustomerName}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    {item?.InvoiceAmount}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    {item?.ReceivedAmount}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    {item?.TDSAmount}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    {item?.Kasar}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    {item?.BankCharges}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    {item?.PendingAmount}
                                  </td>
                                  <td>{item?.PaymentMode}</td>
                                  <td>{item?.ReceivedDetail}</td>
                                  <td>{item?.ReceivableBankName}</td>
                                  <td>{item?.ContactPerson}</td>
                                  <td style={{ textAlign: "left" }}>
                                    {item?.CreatedBy}
                                  </td>
                                </tr>
                              ))}
                            </>
                          ) : (
                            <tr>
                              <td colSpan={19} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                    {PaymentType == 2 && (
                      <table
                        id="AdvanceReceitpRegister-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead className="fixedheader">
                          <tr>
                            <th
                              width="2%"
                              style={{ minWidth: "50px", textAlign: "center" }}
                            >
                              #
                            </th>
                            <th width="7%" style={{ minWidth: "120px" }}>
                              Receipt No
                            </th>
                            <th width="7%" style={{ minWidth: "120px" }}>
                              Receipt Date
                            </th>
                            <th width="20%" style={{ minWidth: "250px" }}>
                              Customer Name
                            </th>
                            <th
                              width="7%"
                              style={{ minWidth: "120px", textAlign: "right" }}
                            >
                              Received Amount
                            </th>
                            <th
                              width="7%"
                              style={{ minWidth: "120px", textAlign: "right" }}
                            >
                              Balance Amount
                            </th>
                            <th width="7%" style={{ minWidth: "120px" }}>
                              Payment Mode
                            </th>
                            <th width="14%" style={{ minWidth: "180px" }}>
                              Received Detail
                            </th>
                            <th width="10%" style={{ minWidth: "120px" }}>
                              Receivable Bank Name
                            </th>
                            <th width="12%" style={{ minWidth: "150px" }}>
                              Contact Person
                            </th>
                            <th
                              width="7%"
                              style={{ minWidth: "130px", textAlign: "left" }}
                            >
                              Entry By
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {advanceReceiptList?.length > 0 ? (
                            <>
                              {advanceReceiptList?.map((item, index) => (
                                <tr key={index}>
                                  <td style={{ textAlign: "center" }}>
                                    {item?.RowNo}
                                  </td>
                                  <td>{item?.ReceiptNo}</td>
                                  <td>{item?.ReceiptDate}</td>

                                  <td
                                    style={{
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item?.CustomerName}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    {item?.AmountReceived}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    {item?.AvailableAmount}
                                  </td>

                                  <td>{item?.PaymentMode}</td>
                                  <td
                                    style={{
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item?.ReceivedDetail}
                                  </td>
                                  <td> {item?.ReceivableBankName}</td>
                                  <td> {item?.ContactPerson}</td>
                                  <td style={{ textAlign: "left" }}>
                                    {item?.CreatedBy}
                                  </td>
                                </tr>
                              ))}
                            </>
                          ) : (
                            <tr>
                              <td colSpan={11} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default PaymentReceiptRegister;
